module.exports = __webpack_public_path__ + "static/2026_kyleKnaggsResume-012e5d404dc3ac1de90be610ffd3c5dd.pdf";